// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"603":"109fa001","726":"7cf627e7","812":"2f7c7d9f","970":"28d8644d"}[chunkId] + ".chunk.css";
};